<template>
  <div class="col-12 col-md-auto product-meta order-3 product-parameter">
    <div class="p-3 p-lg-4 h-100">
      <form action="#" method="POST">
        <ClientOnly>
          <table class="table table-borderless align-middle">
            <tr class="product-qty">
              <span  v-if="!isInStock">
                <h3>{{ $t("sold_out") }}</h3>
                <p>{{ $t("item_out_of_stock") }}</p>
              </span>
              <span v-else>
                <td>
                  <div class="input-group">
                    <button class="btn" type="button" @click="quantityDown">-</button>
                    <input type="text" min="1" class="form-control" :value="quantity" name="quantity" ref="inputQuantity" disabled>
                    <button class="btn" type="button" @click="quantityUp">+</button>
                  </div>
                </td>
              </span>
              <td class="text-end">
                <div
                  v-if="
                    priceRange.minimum_price.final_price.value !=
                    priceRange.maximum_price.final_price.value
                  "
                >
                  <span>
                    <strong class="product-price fs-3">
                      {{
                        formatCurrency(priceRange.minimum_price.final_price.value)
                      }}
                      -{{
                        formatCurrency(priceRange.maximum_price.final_price.value)
                      }}
                    </strong>
                  </span>
                  <span v-if="priceRange.minimum_price.discount.percent_off > 0">
                    <strong class="product-price fs-3">
                      {{ $t("discount") }}
                      {{
                        priceRange.minimum_price.discount.percent_off.toFixed(0)
                      }}%
                    </strong>
                  </span>
                </div>
                <div
                  v-if="
                    priceRange.minimum_price.final_price.value ==
                    priceRange.maximum_price.final_price.value
                  "
                >
                  <span
                    class="normal-price d-block"
                    v-if="product.manufacturer_price && product.manufacturer_price.price.value > 0"
                  >
                    <strong class="product-price fs-3">
                      {{ $t("advice_price") }}:
                      {{ formatCurrency(product.manufacturer_price.price.value) }}
                    </strong>
                  </span>
                  <span
                    class="normal-price d-block"
                  >
                    <strong class="product-price fs-3">
                      {{ formatCurrency(priceRange.minimum_price.final_price.value) }}
                    </strong>
                  </span>
                  <span
                    class="normal-price d-block"
                    v-if="priceRange.minimum_price.discount.percent_off > 0"
                  >
                    <strong class="product-price fs-3">
                      {{ $t("discount") }}
                      {{
                        priceRange.minimum_price.discount.percent_off.toFixed(0)
                      }}%
                    </strong>
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </ClientOnly>
        <div v-if="productBundles && productBundles.length > 0">
          <div class="card mb-3" v-for="(bundleProd, idx) of productBundles" :key="`bund` + bundleProd.option_id">
            <div class="card-body">
              <h5 class="card-title">{{ bundleProd.title }}</h5>
              <template v-if="bundleProd.options && bundleProd.options.length">
                <div v-if="bundleProd.options.length == 1">
                  <span>{{ bundleProd.options[0].label }}</span>
                  <span>
                    + {{ formatCurrency(bundleProd.options[0].price) }}</span
                  >
                </div>
                <div
                  v-for="subOption in bundleProd.options"
                  :key="subOption.id"
                  v-else
                >
                  <div class="form-check ps-5">
                    <input class="form-check-input" type="radio" :id="`option${subOption.id}`" :name="'option' + idx" v-on:click="processOption(bundleProd.option_id, idx, subOption.id)" :checked="selectedBundles[idx].option_selection_id == subOption.id">
                    <label class="form-check-label" for="shipping-dhl">{{ subOption.label }} + {{ formatCurrency(subOption.price) }}</label>
                  </div>
                </div>
                <div class="pro-input">
                  <label class="form-check-label">{{$t("number")}}</label>
                  <input
                    type="text"
                    class="form-control"
                    @change="
                      changeOptionQuantity($event, bundleProd.option_id, idx)
                    "
                    :value="selectedBundles[idx].quantity"
                    :disabled="
                      bundleProd.options[0].can_change_quantity == false
                    "
                    style="width: 15%; display: inline; margin: 10px;"
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
        <button
          type="button"
          v-if="isInStock"
          v-on:click="addToCart"
          v-bind:disabled="btnDisable"
          :style="buttonClass"
          class="btn btn-primary btn-lg d-block mx-auto mx-md-0 mb-4 px-4"
        >
          <ClientOnly><i class="fa-solid fa-basket-shopping me-2"></i></ClientOnly>
          {{ $t("add_to_cart") }}
        </button>
        <div
          class="deliery-info fw-bold"
          v-if="product.DeliveryTime != null"
          :style="'color: ' + product.DeliveryTime.color + '!important'"
          >{{ $t("delivery_time") }}: {{ product.DeliveryTime.long }}<sup>*</sup></div
        >
        <div class="mt-4">
          <strong class="d-block">{{ $t("product_information") }}:</strong>
          Model: {{ product.sku }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";

export default {
  name: "ProductParametersBundle",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ClientOnly
  },
  props: {
    parameters: { type: Object },
    isInWishList: { type: Boolean },
  },
  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
      productConfig: "product/getCurrentConfig",
      productBundles: "product/getCurrentBundle",
      selectedBundles: "product/getSelectedBundles",
      options: "product/getCurrentBundleOptions",
      compareList: "compare/getProductCompare",
      cartItems: "cart/getCartItems",
    }),
    isInStock() {
      if (this.productBundles.length) {
        const status = this.productBundles.every((item) =>
          item.options.every(
            (item1) => item1.product.stock_status == "IN_STOCK"
          )
        );
        return status;
      }
      return this.product.stock_status == "IN_STOCK" ? true : false;
    },
    getGTMItems() {
      let items = {
        item_name: this.product.name,
        item_id: this.product.sku,
        quantity: this.quantity,
        price: this.regularPrice,
        item_brand: this.productBrand,
        discount: this.regularPrice - this.finalPrice,
      };
      return items;
    },
    isProductInCompare() {
      return !!this.compareList.find(
        (product) => product.sku === this.product.sku
      );
    },
    btnDisable() {
      return false;
      /*
      let reval = false;
      const bundle = this.$store.getters["product/getCurrentBundle"];
      Logger.debug("ProductParametersBundle", "btnDisable", bundle)();
      const parentSkus = this.$store.getters["product/getSelectedBundles"];
      const childSkus = this.$store.getters["product/getSelectedChildSkus"];
      bundle.forEach((bundleOption) => {
        Logger.debug(
          "ProductParametersBundle",
          "btnDisable",
          parentSkus[bundleOption.option_id]
        )();
        if (parentSkus[bundleOption.option_id] == null) {
          reval = true;
        }
        if (childSkus[bundleOption.option_id] == null) {
          reval = true;
        }
      });
      return reval;
      */
    },
    buttonClass() {
      if (this.btnDisable == true) {
        return "cursor: not-allowed;";
      } else {
        return "";
      }
    },
    productBrand() {
      let productBrand = "";
      if (this.product.information_attributes) {
        const brand = this.product.information_attributes.find(
          (item) => item.attribute_code == "merk"
        );
        if (brand) {
          productBrand = brand.value;
        }
      }
      return productBrand;
    },
    paymentPartners() {
      return this.$store.getters["sliders/getSliderByIdentifier"](
        "payment_providers"
      );
    },
    priceRange() {
      return this.product.price_range;
    },
    availability() {
      if (this.product.store_availability) {
        return this.product.store_availability;
      }
      return [];
    },
  },

  data: () => ({
    quantity: 1,
    popup: false,
    addToCartModal: false,
    addToNotifyModal: false,
    addToCompareModal: false,
    priceSize: "",
  }),
  methods: {
    toggleIsInWishList() {
      this.$emit("changeIsInWishList");
    },
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    clickOk() {
      this.addToCartModal = false;
      this.$router.push("/checkout");
    },
    clickCancel() {
      this.addToCartModal = false;
      window.scrollTo(0, 0);
    },
    clickOkCompare() {
      this.addToCompareModal = false;
      this.$router.push("/compare");
    },
    clickCancelCompare() {
      this.addToCompareModal = false;
      window.scrollTo(0, 0);
    },
    async onCompareClick() {
      if (this.isProductInCompare == false) {
        await this.$store.dispatch("compare/addCompareProduct", {
          sku: this.product.sku,
        });
        this.addToCompareModal = true;
      } else {
        await this.$store.dispatch("compare/removeCompareProduct", {
          sku: this.product.sku,
        });
      }
    },
    closeNotifyModal() {
      this.addToNotifyModal = false;
    },
    quantityUp() {
      this.quantity++;
    },
    quantityDown() {
      if (this.quantity > 1) this.quantity--;
    },
    processOption(bundle_id, index, value) {
      const quantity = this.selectedBundles[index].quantity;
      this.$store.commit("product/setBundleOptionValue", {
        bundle_id: bundle_id,
        index: index,
        value: value,
        quantity: quantity,
      });
    },
    changeOptionQuantity(event, bundle_id, index) {
      const quantity = parseInt(event.target.value);
      const selectedOption = this.selectedBundles[index].option_selection_id;

      this.$store.commit("product/setBundleOptionValue", {
        bundle_id: bundle_id,
        index: index,
        value: selectedOption,
        quantity,
      });
    },
    addToNotify() {
      this.addToNotifyModal = true;
    },
    async addToCart() {
      switch (this.product.__typename) {
        case "BundleProduct": {
          const selected_options =
            this.$store.getters["product/getSelectedBundlesOptions"];

          let items =
            "{ quantity: " +
            this.quantity +
            ' sku: "' +
            this.product.sku +
            '" selected_options: ' +
            JSON.stringify(selected_options) +
            " }";

          const retval = await this.$store.dispatch("cart/addProductToCart", {
            items: items,
          });

          Logger.debug("retval", "addToCart", retval)();

          if (this.$gtm.enabled()) {
            Logger.debug("Watch Product", "product.vue", "CALLED")();
            window.dataLayer.push({
              event: "eec.add",
              ecommerce: {
                add: {
                  products: [
                    {
                      name: this.product.name,
                      id: this.product.sku,
                      quantity: this.quantity,
                    },
                  ],
                },
              },
            });
            if (this.$gtm.ga4Enabled) {
              window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                  add: {
                    currency: "EUR",
                    value: this.product.final_price,
                    items: [this.getGTMItems()],
                  },
                },
              });
            }
          }
          if (retval == false) {
            const msg = {
              type: "danger",
              title: this.$t("add_to_cart"),
              text: this.$t("not_add_product"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          } else {
            this.addToCartModal = true;
            setTimeout(() => {
              this.addToCartModal = false;
            }, 5000);
            // this.$bvModal.show("modal-1");
          }
          break;
        }

        default:
          break;
      }
    },
  },
 
};
</script>

